import { Controller } from "@hotwired/stimulus"

/**
 * Lightweight table row filter — hides rows whose text content
 * doesn't match the search term (case-insensitive).
 *
 * Usage:
 *   <div data-controller="inline-search">
 *     <input data-inline-search-target="input"
 *            data-action="input->inline-search#filter"
 *            placeholder="Search...">
 *     <table>
 *       <tr data-inline-search-target="row">...</tr>
 *     </table>
 *   </div>
 */
export default class extends Controller {
  static targets = ["input", "row"]

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase()

    this.rowTargets.forEach((row) => {
      if (!query) {
        row.classList.remove("hidden")
        return
      }
      const text = row.textContent.toLowerCase()
      row.classList.toggle("hidden", !text.includes(query))
    })
  }
}
